var map = {
	"./": 1354,
	"./Clutch": 2660,
	"./Clutch.js": 2660,
	"./NewUi": 2661,
	"./NewUi.js": 2661,
	"./OldUi": 2662,
	"./OldUi.js": 2662,
	"./index": 1354,
	"./index.js": 1354,
	"./style": 852,
	"./style.js": 852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4187;